import React from "react";
import { motion } from "framer-motion";
import { IoClose } from "react-icons/io5";
import { FaCheck, FaMinus, FaPlus } from "react-icons/fa6";
import { comparisonData, comparisonGrid } from "../Data";

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 35,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const headingVariant = {
  hidden: {
    opacity: 0,
    y: -50,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const textVariant = {
  hidden: {
    opacity: 0,
    y: 35,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      delay: .2,
      duration: .7,
    },
  },
};

const gridContainer = {
  hidden: {},
  visible: {
    transition: {
      delayChildren: 1.2,
      staggerChildren: .18,
    },
  },
};

const smallCard = {
  hidden: {
    opacity: 0,
    y: 60,
    scale: .9,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: .6,
      ease: [0.22,1,0.36,1],
    },
  },
};

const ComparisonCard = ({ item }) => {
  const isSuccess = item.type === "after";

  return (
     <motion.div
  className={`comparison-card ${
    isSuccess ? "success-card" : "danger-card"
  }`}
  variants={cardVariant}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.3 }}
  whileHover={{
    y: -6,
    scale: 1.015,
  }}
  transition={{
    duration: 0.45,
    ease: [0.22, 1, 0.36, 1],
  }}
>
      <div className="comparison-top">

      <motion.div
  className={`icon-box ${
    isSuccess ? "success-icon" : "danger-icon"
  }`}
  animate={{
    scale: [1, 1.04, 1],
  }}
  transition={{
    duration: 2.5,
    repeat: Infinity,
    ease: "easeInOut",
  }}
>
          {isSuccess ? <FaCheck /> : <IoClose />}
        </motion.div>

        <div>

       <motion.h3
  className="card-heading"
  initial={{ opacity: 0, y: 12 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{
    duration: 0.45,
    delay: 0.15,
  }}
>
            {item.heading}
          </motion.h3>

         <motion.p
  className="section-text"
  initial={{ opacity: 0, y: 12 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{
    duration: 0.45,
    delay: 0.25,
  }}
>
            {item.description}
          </motion.p>

        </div>

      </div>

     <motion.div
  className="comparison-list"
  variants={{
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.3,
      },
    },
  }}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
        {item.points.map((point, index) => (

        <motion.div
  className="comparison-item"
  key={index}
  variants={{
    hidden: {
      opacity: 0,
      y: 12,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.35,
      },
    },
  }}
>
            <motion.div
              className={`bullet ${
                isSuccess ? "success-icon" : "danger-icon"
              }`}
              whileHover={{
                scale: 1.15,
              }}
              transition={{
                duration: 0.45,
              }}
            >
              {isSuccess ? <FaPlus /> : <FaMinus />}
            </motion.div>

            <motion.span
              className="section-text"
              whileHover={{
                x: 6,
              }}
            >
              {point}
            </motion.span>

          </motion.div>

        ))}
      </motion.div>
    </motion.div>
  );
};

const StartScalingConversationsSection=()=>{
    return(
        <>
       <section className="comparison-section container">

    <motion.h2
        className="section-heading"
        variants={headingVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once:true }}
    >
        Stop managing chaos. Start scaling{" "}
        <span>
            conversations.
        </span>
    </motion.h2>

    <motion.p
        className="section-text top-text"
        variants={textVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once:true }}
    >
        Turn scattered chats into organized, automated conversations that drive engagement and accelerate business growth.
    </motion.p>

    <div className="comparison-wrapper">

        {comparisonData.map((item)=>(
            <ComparisonCard
                key={item.id}
                item={item}
            />
        ))}

      {/*  <motion.div
  className="comparison-arrow"
  initial={{
    opacity: 0,
  }}
  whileInView={{
    opacity: 1,
  }}
  viewport={{ once: true }}
  transition={{
    delay: 0.8,
    duration: 0.01,
  }}
>

 <motion.div
    className="comparison-arrow-circle"
    initial={{
      scale: 0,
    }}
    whileInView={{
      scale: 1,
    }}
    viewport={{ once: true }}
    transition={{
      delay: 0.8,
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
    }}
  >
    <motion.div
      initial={{
        opacity: 0,
        scale: 0.5,
      }}
      whileInView={{
        opacity: 1,
        scale: 1,
      }}
      viewport={{ once: true }}
      transition={{
        delay: 1.15,
        duration: 0.35,
      }}
    >
      <FaArrowRight />
    </motion.div>
  </motion.div>

</motion.div>*/}

    </div>

    <motion.div
        className="comparison-grid"
        variants={gridContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once:true }}
    >

        {comparisonGrid.map((item,i)=>(
            <motion.div
                key={i}
                className="comparison-small-card"
                variants={smallCard}
                whileHover={{
                    y:-10,
                    scale:1.03,
                    rotateX:5,
                    rotateY:i%2===0?-5:5,
                }}
            >

                <motion.div
                    className="comparison-icon-wrapper"
                    whileHover={{
                        scale:1.1,
                    }}
                    transition={{
                        duration:.5,
                    }}
                >
                    <img
                        src={item.icon}
                        alt={`${item.title} ${item.desc} | Onbbits`}
                    />
                </motion.div>

                <div className="comparison-small-card-col">

                    <h3 className="card-heading">
                        {item.title}
                    </h3>

                    <p className="section-text">
                        {item.desc}
                    </p>

                </div>

            </motion.div>
        ))}

    </motion.div>

</section>
        </>
    )
}
export default StartScalingConversationsSection;